import { types } from 'mobx-state-tree';

import ROLES from 'utils/constants/roles';

export const RolesEnum = types.enumeration(Object.values(ROLES));

export default RolesEnum;
